import {
  type GetSessionsAnalyticsActivityArgs,
  useLazyGetSessionsAnalyticsActivityQuery,
} from '@carboncopyco/data';
import type { Resolution } from '@carboncopyco/types';
import {
  getDateFromDaysAgo,
  getNowInFormat,
  getTimezoneName,
} from '@carboncopyco/utils';
import { useEffect, useMemo, useState } from 'react';
import { SingleBarChart, useGetActivityChartConfig } from '../../../Charts';
import { usePlaybookPageProps } from '../PlaybookPageContext';
import type { TimePeriod } from '../types';

export const ActivityOverTime = () => {
  const { organizationId, playbookId, workspaceId } = usePlaybookPageProps();
  const [timePeriod, setTimePeriod] = useState<TimePeriod>('30');
  const [resolution, setResolution] = useState<Resolution>('day');

  const fetchArgs = useMemo<GetSessionsAnalyticsActivityArgs>(
    () => ({
      organizationId,
      shortSessions: true,
      internalSessions: true,
      workspaceIds: [workspaceId],
      start: getDateFromDaysAgo(Number(timePeriod)),
      end: getNowInFormat('YYYY-MM-DDTHH:mm:ssZ'),
      timezone: getTimezoneName(),
      resolution,
      playbookId,
      resourceTypes: ['play'],
    }),
    [organizationId, workspaceId, timePeriod, resolution, playbookId]
  );

  const [getManagedPresentationOverTimeChart, { data, isFetching, isError }] =
    useLazyGetSessionsAnalyticsActivityQuery();

  useEffect(() => {
    getManagedPresentationOverTimeChart(fetchArgs);
  }, [fetchArgs, getManagedPresentationOverTimeChart]);

  const chartData = useGetActivityChartConfig(data, 'presented', timePeriod);
  const isEmpty = !data?.results.length;

  useEffect(() => {
    if (timePeriod === '7') {
      setResolution('day');
    }
  }, [timePeriod]);

  return (
    <SingleBarChart
      isLoading={isFetching}
      isError={isError}
      isEmpty={isEmpty}
      chartData={chartData}
      resolution={resolution}
      setResolution={setResolution}
      timePeriod={timePeriod}
      setTimePeriod={setTimePeriod}
      chartHeight={210}
    />
  );
};
